import React from "react";
import Sidebar from "../../../components/Sidebar";
import QuizComplete from "../../../components/quizComplete/QuizComplete";

const QuizCompletePage = () => {
  return (
    <Sidebar>
      <QuizComplete />
    </Sidebar>
  );
};

export default QuizCompletePage;
